<div class="modal-dialog m-0" style="max-width: 100%">
  <div class="modal-content" style="border: none">
    <app-modal-header-common [title]="'Risk Update'" [dialogRef]="dialogRef">
    </app-modal-header-common>
    <div class="form-scrollable-area" style="height: 70vh; max-height: 70vh">
      <div class="modal-body p-0">
        <div class="dialog-top-container">
          <div class="dialog-top-left">
            <div class="px-3 py-3">
              <ul>
                <li *ngFor="
                    let breadcrumb of breadCrumbData;
                    first as isFirst;
                    last as isLast
                  ">
                  <span *ngIf="!isLast" class="color-history-inactive">{{
                    breadcrumb
                    }}</span>
                  <span *ngIf="isLast" class="color-active">{{ breadcrumb }}</span>
                </li>
              </ul>
            </div>
            <div class="row" style="padding-left: 29px; font-size: 14px">
              {{ riskMetric.domain }} | {{ riskMetric.subdomain }} |
              <ng-container *ngIf="res?.risk_custom_id">{{res.risk_custom_id}} - </ng-container>{{ riskMetric.risk }}
            </div>
            <div class="saw">
              <div class="d-flex mb-2" style="align-items: center">
                <span class="sjec gol">Risk Type: </span>
                <span>{{ res.risk_type?.display_name }}
                </span>
              </div>
              <div class="d-flex mb-2" style="align-items: center">
                <span class="sjec gol">Risk State: </span>
                <div class="response-toggle" [class.disabled]="isReadOnlyStatus()">
                  <button type="button" class="response-btn"
                    [class.active-accept]="riskMetric.risk_response === 'Accept'" [disabled]="isReadOnlyStatus()"
                    (click)="setRiskResponse('Accept')">
                    Accept
                  </button>
                  <button type="button" class="response-btn"
                    [class.active-mitigate]="riskMetric.risk_response === 'Mitigate'" [disabled]="isReadOnlyStatus()"
                    (click)="setRiskResponse('Mitigate')">
                    Mitigate
                  </button>
                </div>
              </div>
            </div>
            <!-- Inherent Risk Score Row (Shown ONLY for Accept response at top) -->
            <div *ngIf="riskMetric.risk_response === 'Accept'" class="risk-score-row" style="margin-left:20px;">
              <div class="risk-field">
                <label>Risk Impact</label>
                <mat-form-field appearance="outline">
                  <mat-select [value]="selectedRiskImpact?.id" (selectionChange)="onImpactChange($event.value)"
                    [disabled]="isReadOnlyStatus()">
                    <mat-option *ngFor="let item of riskImpactList" [value]="item.id">
                      {{ item.display_name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Risk Likelihood -->
              <div class="risk-field">
                <label>Risk Likelihood</label>
                <mat-form-field appearance="outline">
                  <mat-select [value]="selectedRiskLikelihood?.id" (selectionChange)="onLikelihoodChange($event.value)"
                    [disabled]="isReadOnlyStatus()">
                    <mat-option *ngFor="let item of riskLikelihoodList" [value]="item.id">
                      {{ item.display_name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Inherent Risk Score -->
              <div class="risk-field">
                <label>Inherent Risk Score</label>
                <div class="score-box" [ngStyle]="{ 'background-color': getRiskScoreColor(), color: 'white' }">
                  {{ inherentRiskScore || '0' }}
                </div>
              </div>
            </div>
          </div>
          <div class="dialog-top-right">
            <app-llm-inference inferenceType="risk" [outputRef]="{ project_risk_id: res?.id }"></app-llm-inference>
          </div>
        </div>
        <mat-tab-group [(selectedIndex)]="selectedMainTabIndex">
          <mat-tab label="Risk State">
            <form [formGroup]="riskMetricAcceptCreateForm" *ngIf="riskMetric.risk_response == 'Accept'"
              class="accept-form">
              <!-- Closed Date -->
              <div class="form-row">
                <div class="form-label">Closed Date</div>

                <mat-form-field class="w-25" appearance="outline">
                  <input matInput [matDatepicker]="picker" readonly formControlName="due_date"
                    (click)="picker.open()" />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>

              <!-- Comments -->
              <div class="form-row">
                <div class="form-label">Comments</div>

                <mat-form-field class="w-50" appearance="outline">
                  <textarea matInput formControlName="comments" cdkTextareaAutosize cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="6"></textarea>
                </mat-form-field>
              </div>

              <!-- Upload Files -->
              <div class="form-row">
                <div class="form-label">Upload Files</div>

                <div class="upload-box p-3 rounded border" style="
                    background-color: #f9f9f9;
                    position: relative;
                    max-width: 50%;
                  ">
                  <input #fileUpload type="file" (change)="onFileSelected($event)" multiple hidden
                    [disabled]="isReadOnlyStatus()" />

                  <button mat-stroked-button color="primary" (click)="fileUpload.click()" type="button"
                    [disabled]="isReadOnlyStatus()">
                    <mat-icon class="me-2">cloud_upload</mat-icon>
                    Upload File
                  </button>

                  <div class="d-flex gap-3 mt-3" style="overflow-x: auto; white-space: nowrap">
                    <!-- New files -->
                    <div *ngFor="let file of uploadFiles; let i = index"
                      class="d-flex justify-content-between p-2 border rounded bg-white" style="width: 200px">
                      <mat-icon>insert_drive_file</mat-icon>

                      <span class="filename-ellipsis" [matTooltip]="file.name">
                        {{ file.name }}
                      </span>

                      <button mat-icon-button color="warn" (click)="removeFile(i)" [disabled]="isReadOnlyStatus()">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>

                    <!-- Existing files -->
                    <div *ngFor="let file of uploadedFiles; let i = index"
                      class="d-flex justify-content-between p-2 border rounded bg-white" style="width: 200px">
                      <div class="d-flex align-items-center w-50">
                        <mat-icon class="me-1">insert_drive_file</mat-icon>
                        <span class="filename-ellipsis" [matTooltip]="file.file_name">
                          {{ file.file_name }}
                        </span>
                      </div>

                      <button mat-icon-button matTooltip="Download" (click)="downloadRiskFile(file.id)">
                        <mat-icon>cloud_download</mat-icon>
                      </button>

                      <button mat-icon-button color="warn" matTooltip="Remove" (click)="removeUploadedFile(file.id, i)"
                        [disabled]="isReadOnlyStatus()">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="riskMetric.risk_response === 'Accept' && showResidualSection" class="risk-score-row"
                style="margin-top:10px; max-width:850px;">
                <!-- Residual Risk Impact -->
                <div class="risk-field">
                  <label>Residual Risk Impact</label>
                  <mat-form-field appearance="outline">
                    <mat-select [value]="selectedResidualImpact?.id"
                      (selectionChange)="onResidualImpactChange($event.value)"
                      [disabled]="isClosedByCro() || isReadOnlyStatus()">
                      <mat-option *ngFor="let item of riskImpactList" [value]="item.id">
                        {{ item.display_name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <!-- Residual Risk Likelihood -->
                <div class="risk-field">
                  <label>Residual Risk Likelihood</label>
                  <mat-form-field appearance="outline">
                    <mat-select [value]="selectedResidualLikelihood?.id"
                      (selectionChange)="onResidualLikelihoodChange($event.value)"
                      [disabled]="isClosedByCro() || isReadOnlyStatus()">
                      <mat-option *ngFor="let item of riskLikelihoodList" [value]="item.id">
                        {{ item.display_name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <!-- Residual Risk Score -->
                <div class="risk-field">
                  <label>Residual Risk Score</label>
                  <div class="score-box"
                    [ngStyle]="{ 'background-color': getResidualRiskScoreColor(), color: 'white' }">
                    {{ residualRiskScore ?? '0' }}
                  </div>
                </div>
              </div>
              <div class="checkbox-row">
                <mat-checkbox class="risk-warning-checkbox" [checked]="isClosed()"
                  (change)="toggleStatus($event.checked)" [disabled]="isReadOnlyStatus()">
                  <span class="checkbox-text" [ngClass]="{ 'checkbox-error': showCheckboxError }">
                    This risk is backed by adequate preventive, detective & mitigation
                    controls - accepting it does not pose material exposure to
                    the business.
                  </span>
                </mat-checkbox>
              </div>
            </form>

            <form [formGroup]="riskMetricCreateForm" *ngIf="riskMetric.risk_response == 'Mitigate'" class="accept-form">
              <!-- Application Setup Section -->
              <div class="mt-2 mb-3">
                <h6 class="mb-2 text-dark fw-bold" style="font-size: 14px;">Application Setup</h6>
                <div class="app-setup-row">
                  <div class="risk-field">
                    <label>Application</label>
                    <app-searchable-dropdown class="w-100" [formControl]="applicationControl"
                      [options]="projectApplications" labelKey="name" [valueKey]="'id'"
                      placeholder="Search Application..." noResultsText="No applications found"
                      [disabled]="isReadOnlyStatus()" (selectionChange)="onApplicationChange($event?.id ?? null)">
                    </app-searchable-dropdown>
                  </div>

                  <div class="risk-field">
                    <label>Components / Assets</label>
                    <mat-form-field appearance="outline">
                      <mat-select [value]="selectedInfrastructureIds"
                        (selectionChange)="selectedInfrastructureIds = $event.value" multiple
                        [disabled]="isReadOnlyStatus() || !selectedApplicationId">
                        <div class="p-2 sticky-top bg-white" (click)="$event.stopPropagation()"
                          (keydown)="$event.stopPropagation()">
                          <input matInput class="form-control form-control-sm" placeholder="Search Component..."
                            [(ngModel)]="infraSearchText" [ngModelOptions]="{standalone: true}">
                        </div>
                        <mat-option *ngFor="let infra of filteredInfrastructures" [value]="infra.id">
                          {{ infra.infrastructure_name || infra.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="risk-field">
                    <label>Business Services / Processes</label>
                    <mat-form-field appearance="outline">
                      <mat-select [value]="selectedServiceIds" (selectionChange)="selectedServiceIds = $event.value"
                        multiple [disabled]="isReadOnlyStatus() || !selectedApplicationId">
                        <div class="p-2 sticky-top bg-white" (click)="$event.stopPropagation()"
                          (keydown)="$event.stopPropagation()">
                          <input matInput class="form-control form-control-sm" placeholder="Search Business Service..."
                            [(ngModel)]="serviceSearchText" [ngModelOptions]="{standalone: true}">
                        </div>
                        <mat-option *ngFor="let svc of filteredServices" [value]="svc.id">
                          {{ svc.service_name || svc.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <!-- Scoring Assessment Section -->
              <div class="mb-3">
                <h6 class="mb-2 text-dark fw-bold" style="font-size: 14px;">Scoring Assessment</h6>
                <div class="row g-3">
                  <!-- Left Half: Inherent Risk Scoring -->
                  <div class="col-md-6">
                    <div class="p-3 border rounded bg-white" style="box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <div class="fw-bold text-secondary" style="font-size: 12px; letter-spacing: 0.5px;">INHERENT
                          RISK ASSESSMENT</div>
                        <div class="d-flex align-items-center gap-2">
                          <span style="font-size: 11px; color: #666; font-weight: 600;">Score:</span>
                          <div class="score-box"
                            [ngStyle]="{ 'background-color': getRiskScoreColor(), color: 'white' }">
                            {{ inherentRiskScore || '0' }}
                          </div>
                        </div>
                      </div>
                      <div class="row g-2">
                        <div class="scoring-field col-4">
                          <label>Inherent Impact</label>
                          <mat-form-field appearance="outline" class="w-100 mb-0">
                            <mat-select [value]="selectedRiskImpact?.id"
                              (selectionChange)="onImpactChange($event.value)" [disabled]="isReadOnlyStatus()">
                              <mat-option *ngFor="let item of riskImpactList" [value]="item.id">
                                {{ item.display_name }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>

                        <div class="scoring-field col-4">
                          <label>Inherent Likelihood</label>
                          <mat-form-field appearance="outline" class="w-100 mb-0">
                            <mat-select [value]="selectedRiskLikelihood?.id"
                              (selectionChange)="onLikelihoodChange($event.value)" [disabled]="isReadOnlyStatus()">
                              <mat-option *ngFor="let item of riskLikelihoodList" [value]="item.id">
                                {{ item.display_name }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>

                        <div class="scoring-field col-4">
                          <label>Asset Valuation</label>
                          <mat-form-field appearance="outline" class="w-100 mb-0">
                            <mat-select [value]="selectedAssetImpact?.id"
                              (selectionChange)="onAssetImpactChange($event.value)"
                              [disabled]="isReadOnlyStatus() || !selectedApplicationId">
                              <mat-option [value]="null">-- None --</mat-option>
                              <mat-option *ngFor="let item of assetImpactList" [value]="item.id">
                                {{ item.display_name }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Right Half: Residual Risk Scoring -->
                  <div class="col-md-6">
                    <div class="p-3 border rounded bg-white" style="box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <div class="fw-bold text-secondary" style="font-size: 12px; letter-spacing: 0.5px;">RESIDUAL
                          RISK ASSESSMENT</div>
                        <div class="d-flex align-items-center gap-2">
                          <span style="font-size: 11px; color: #666; font-weight: 600;">Score:</span>
                          <div class="score-box"
                            [ngStyle]="{ 'background-color': getEffectiveResidualRiskScoreColor(), color: 'white' }">
                            {{ effectiveResidualRiskScore ?? '0' }}
                          </div>
                        </div>
                      </div>
                      <div class="row g-2">
                        <div class="scoring-field col-4">
                          <label>Residual Impact</label>
                          <mat-form-field appearance="outline" class="w-100 mb-0">
                            <mat-select [value]="effectiveResidualImpact?.id"
                              (selectionChange)="onResidualImpactChange($event.value)"
                              [disabled]="!hasActions || isClosedByCro() || isReadOnlyStatus()">
                              <mat-option *ngFor="let item of riskImpactList" [value]="item.id">
                                {{ item.display_name }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>

                        <div class="scoring-field col-4">
                          <label>Residual Likelihood</label>
                          <mat-form-field appearance="outline" class="w-100 mb-0">
                            <mat-select [value]="effectiveResidualLikelihood?.id"
                              (selectionChange)="onResidualLikelihoodChange($event.value)"
                              [disabled]="!hasActions || isClosedByCro() || isReadOnlyStatus()">
                              <mat-option *ngFor="let item of riskLikelihoodList" [value]="item.id">
                                {{ item.display_name }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>

                        <div class="scoring-field col-4">
                          <label>Asset Valuation</label>
                          <mat-form-field appearance="outline" class="w-100 mb-0">
                            <mat-select [value]="selectedAssetImpact?.id" [disabled]="true">
                              <mat-option [value]="null">-- None --</mat-option>
                              <mat-option *ngFor="let item of assetImpactList" [value]="item.id">
                                {{ item.display_name }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="margin-top:8px;">
                <!-- Preventive Controls -->
                <div class="col-md-6">
                  <h6 class="mb-2">Preventive Controls</h6>

                  <div class="table-container table-responsive control-table">
                    <table class="table table-bordered">
                      <thead style="position: sticky; z-index: 1; top: 0; background: white">
                        <tr>
                          <th class="text-center">#</th>
                          <th class="w-100 text-center">Control</th>
                          <th class="text-center" style="width: 150px;">Type</th>
                          <th class="text-center">Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr *ngFor="let ctrl of preventiveControls.controls; let i = index; let isLast = last"
                          [formGroup]="ctrl">
                          <td class="text-center">{{ i + 1 }}</td>

                          <td class="pt-2">
                            <mat-form-field appearance="outline" style="width: 100%">
                              <mat-label>Control</mat-label>
                              <textarea matInput formControlName="description"
                                [matAutocomplete]="preventiveAuto" (input)="onControlInput(ctrl)" cdkTextareaAutosize
                                cdkAutosizeMinRows="1" cdkAutosizeMaxRows="6">
                              </textarea>
                              <mat-autocomplete #preventiveAuto="matAutocomplete" [displayWith]="displayControl"
                                (optionSelected)="onControlSelected($event.option.value, ctrl)">
                                <mat-option *ngFor="let opt of getFilteredControls('preventive')" [value]="opt">
                                  {{ opt.description }}
                                </mat-option>
                              </mat-autocomplete>
                            </mat-form-field>
                          </td>

                          <td class="pt-2">
                            <mat-form-field appearance="outline" style="width: 150px">
                              <mat-label>Type</mat-label>
                              <mat-select formControlName="type">
                                <mat-option *ngFor="let type of riskControlTypes" [value]="type.id">
                                  {{ type.display_name }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </td>

                          <td class="text-center">
                            <button *ngIf="isLast" mat-icon-button color="primary" (click)="addPreventiveControl()"
                              [disabled]="isReadOnlyStatus()">
                              <mat-icon>add</mat-icon>
                            </button>

                            <button mat-icon-button color="warn" (click)="removePreventiveControl(i)"
                              [disabled]="isReadOnlyStatus()">
                              <img src="./assets/images/delete.svg" height="18" />
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Detective Controls -->
                <div class="col-md-6">
                  <h6 class="mb-2">Detective Controls</h6>

                  <div class="table-container table-responsive control-table">
                    <table class="table table-bordered">
                      <thead style="position: sticky; z-index: 1; top: 0; background: white">
                        <tr>
                          <th class="text-center">#</th>
                          <th class="w-100 text-center">Control</th>
                          <th class="text-center" style="width: 150px;">Type</th>
                          <th class="text-center">Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr *ngFor="let ctrl of detectiveControls.controls; let i = index; let isLast = last"
                          [formGroup]="ctrl">
                          <td class="text-center">{{ i + 1 }}</td>

                          <td>
                            <mat-form-field appearance="outline" style="width: 100%">
                              <mat-label>Control</mat-label>
                              <textarea matInput formControlName="description"
                                [matAutocomplete]="detectiveAuto" (input)="onControlInput(ctrl)" cdkTextareaAutosize
                                cdkAutosizeMinRows="1" cdkAutosizeMaxRows="6">
                              </textarea>
                              <mat-autocomplete #detectiveAuto="matAutocomplete" [displayWith]="displayControl"
                                (optionSelected)="onControlSelected($event.option.value, ctrl)">
                                <mat-option *ngFor="let opt of getFilteredControls('detective')" [value]="opt">
                                  {{ opt.description }}
                                </mat-option>
                              </mat-autocomplete>
                            </mat-form-field>
                          </td>

                          <td class="pt-2">
                            <mat-form-field appearance="outline" style="width: 150px">
                              <mat-label>Type</mat-label>
                              <mat-select formControlName="type">
                                <mat-option *ngFor="let type of riskControlTypes" [value]="type.id">
                                  {{ type.display_name }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </td>

                          <td class="text-center">
                            <button *ngIf="isLast" mat-icon-button color="primary" (click)="addDetectiveControl()"
                              [disabled]="isReadOnlyStatus()">
                              <mat-icon>add</mat-icon>
                            </button>

                            <button mat-icon-button color="warn" (click)="removeDetectiveControl(i)"
                              [disabled]="isReadOnlyStatus()">
                              <img src="./assets/images/delete.svg" height="18" />
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="task-toolbar">
                <h6>Mitigation Tasks</h6>
                <div class="toolbar-actions" style="display: flex; align-items: center; gap: 16px;">
                  <div class="star-legend-item"
                    style="display: flex; align-items: center; gap: 4px; font-size: 12px; color: #555; font-weight: 500;">
                    <mat-icon class="master-star-icon"
                      style="font-size: 16px; width: 16px; height: 16px; color: #f59e0b; display: inline-flex; align-items: center; justify-content: center;">star</mat-icon>
                    <span>Mitigation from Risk Register</span>
                  </div>

                  <button type="button" mat-button mat-flat-button color="primary" (click)="addMetricItems()"
                    [disabled]="isClosedByCro() || projectOwner" style="height: 36px;">
                    <mat-icon>add</mat-icon>
                    Mitigation Task
                  </button>
                </div>
              </div>
              <app-loading *ngIf="!isLoaded"></app-loading>
              <ng-template #mitigationPanelTemplate let-i="index" let-m="m" let-displayIndex="displayIndex">
                <mat-expansion-panel #panelElement [formGroup]="m">
                  <mat-expansion-panel-header>
                    <div class="panel-header" [style.opacity]="m.value.is_ignored ? '0.5' : '1'">
                      <!-- 1. LEFT SIDE: TASK TITLE & TAGS -->
                      <div class="panel-summary">
                        <span class="task-index"> {{ displayIndex + 1 }}. </span>

                        <span class="task-name" [matTooltip]="m.value.mitigation_task"
                          [style.text-decoration]="m.value.is_ignored ? 'line-through' : 'none'">
                          {{ m.value.mitigation_task || "Mitigation Task" }}
                        </span>

                        <mat-icon *ngIf="m.value.master_mitigation" class="master-star-icon"
                          matTooltip="Master Mitigation Task">star</mat-icon>

                        <span *ngIf="m.value.is_ignored" class="ignored-tag">
                          Ignored
                        </span>
                      </div>

                      <!-- 2. MIDDLE METADATA COLUMNS (FIXED POSITIONS) -->
                      <div class="panel-meta-columns">
                        <span class="summary-item owner-item"
                          [matTooltip]="delegatedUserNameMap?.[m.value.delegated_to]">
                          {{ delegatedUserNameMap?.[m.value.delegated_to] || "Delegated To" }}
                        </span>

                        <span class="summary-item date-item">
                          {{ (m.value.due_date | appFormat: "date") || "Due Date" }}
                        </span>

                        <span class="summary-item status-item" [ngClass]="{
                            'status-open':   (m.getRawValue().status || 'Open') === 'Open',
                            'status-closed': m.getRawValue().status === 'Closed'
                          }">
                          {{ m.getRawValue().status || "Open" }}
                        </span>
                      </div>

                      <!-- 3. ACTIONS SLOT -->
                      <div class="panel-actions-slot"
                        [class.has-review-actions]="!m.value.has_action && projectOwner && m.value.delegated_to && m.value.due_date">
                        <!-- DECISION ACTIONS RIGHT -->
                        <div class="decision-actions"
                          *ngIf="!m.value.has_action && projectOwner && m.value.delegated_to && m.value.due_date"
                          (click)="$event.stopPropagation()" style="display: flex; align-items: center; gap: 6px;">
                          <div class="action-chip approve-chip" [class.selected]="m.value.review_decision === 'Approve'"
                            matTooltip="Approve Task" (click)="setDecision(m, 'Approve')">
                            <mat-icon>check</mat-icon>
                          </div>
                          <div class="action-chip reject-chip" [class.selected]="m.value.review_decision === 'Reject'"
                            matTooltip="Reject Task" (click)="setDecision(m, 'Reject')">
                            <mat-icon>close</mat-icon>
                          </div>
                          <div *ngIf="!m.value.master_mitigation" class="action-chip add-master-chip"
                            [class.selected]="m.value.add_to_master"
                            [class.disabled-chip]="m.value.review_decision !== 'Approve'"
                            [matTooltip]="m.value.review_decision === 'Approve' ? (m.value.add_to_master ? 'Added to Master Mitigations' : 'Add to Master Mitigations') : 'Approve task to add to Master Mitigations'"
                            (click)="toggleAddToMaster(m)">
                            <mat-icon>add</mat-icon>
                          </div>
                        </div>

                        <!-- DELETE / IGNORE BUTTON RIGHT -->
                        <button mat-icon-button type="button" [color]="m.value.is_ignored ? 'primary' : 'warn'"
                          [matTooltip]="m.value.is_ignored ? 'Un-ignore Task' : (m.value.master_mitigation ? 'Ignore Task' : 'Delete Task')"
                          (click)="$event.stopPropagation(); removeMetric(i)"
                          *ngIf="!isClosedByCro() && !projectOwner && !m.value.has_action">
                          <mat-icon>{{ m.value.is_ignored ? 'undo' : (m.value.master_mitigation ? 'block' : 'delete')
                            }}</mat-icon>
                        </button>
                      </div>
                    </div>
                  </mat-expansion-panel-header>

                  <!-- PANEL CONTENT -->
                  <div class="p-2">
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Mitigation Task</mat-label>
                      <textarea matInput formControlName="mitigation_task"
                        [readonly]="isClosedByCro() || projectOwner || m.value.has_action || m.value.is_ignored"
                        cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="6"></textarea>
                    </mat-form-field>

                    <div class="grid-row">
                      <mat-form-field appearance="outline">
                        <mat-label>Type</mat-label>
                        <mat-select formControlName="type"
                          [disabled]="isClosedByCro() || projectOwner || m.value.has_action || m.value.is_ignored">
                          <mat-option *ngFor="let type of riskControlTypes" [value]="type.id">
                            {{ type.display_name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <app-searchable-dropdown class="w-100" labelText="Function" formControlName="function"
                        [options]="mitigationFunctions" [valueKey]="'id'" [labelKey]="'display_name'"
                        [disabled]="isClosedByCro() || projectOwner || m.value.has_action || m.value.is_ignored"
                        (selectionChange)="onFunctionChange($event?.id ?? null, i)">
                      </app-searchable-dropdown>

                      <mat-form-field appearance="outline">
                        <mat-label>Function Owner</mat-label>
                        <input matInput [value]="functionOwners?.[i]" readonly />
                      </mat-form-field>

                      <app-searchable-dropdown class="w-100" labelText="Risk Owner" formControlName="delegated_to"
                        [options]="delegatedUsersList[i]" [valueKey]="'email'" [displayWith]="displayDelegatedUser"
                        [searchKeys]="['first_name', 'last_name']"
                        [disabled]="isClosedByCro() || projectOwner || m.value.has_action || m.value.is_ignored">
                      </app-searchable-dropdown>

                      <mat-form-field appearance="outline">
                        <mat-label>Due Date</mat-label>
                        <input matInput [matDatepicker]="picker" formControlName="due_date" readonly
                          (click)="!isClosedByCro() && !projectOwner && !m.value.has_action && !m.value.is_ignored && picker.open()" />
                        <mat-datepicker-toggle matSuffix [for]="picker"
                          [disabled]="isClosedByCro() || projectOwner || m.value.has_action || m.value.is_ignored"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                      <mat-form-field appearance="outline">
                        <mat-label>Status</mat-label>
                        <mat-select formControlName="status" [disabled]="isStatusDisabled(m)">
                          <mat-option value="Open">Open</mat-option>
                          <mat-option value="Closed">Closed</mat-option>
                        </mat-select>
                      </mat-form-field>

                      <div style="display: flex; align-items: baseline;">
                        <mat-form-field appearance="outline" style="flex: 1;">
                          <mat-label>Risk Owner Comments</mat-label>
                          <textarea matInput formControlName="action_comments"
                            [readonly]="!(projectOwner && m.value.status === 'Closed')" cdkTextareaAutosize
                            cdkAutosizeMinRows="1" cdkAutosizeMaxRows="6"></textarea>
                        </mat-form-field>
                        <button *ngIf="actionIdMap[i]" mat-icon-button (click)="openActionHistoryDialog(actionIdMap[i])"
                          matTooltip="View Action History">
                          <mat-icon>history</mat-icon>
                        </button>
                      </div>




                    </div>

                    <!-- Attachments -->
                    <p>Uploaded Files</p>

                    <div class="attachment-section">
                      <!-- No files state -->
                      <div *ngIf="!actionFileList[i] || actionFileList[i].length === 0" class="text-muted"
                        style="padding: 4px;">
                        -
                      </div>
                      <div *ngFor="let file of actionFileList[i] || []" class="attachment-item">
                        <mat-icon>insert_drive_file</mat-icon>

                        <span [matTooltip]="file.file_name" class="filename-ellipsis">{{ file.file_name }}</span>

                        <button mat-icon-button (click)="downloadFile(file.id, file.file_name)">
                          <mat-icon>cloud_download</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </mat-expansion-panel>
              </ng-template>

              <mat-tab-group *ngIf="isLoaded" dynamicHeight class="mt-2 mitigation-tabs"
                [(selectedIndex)]="activeTabIndex">
                <mat-tab label="For Review ({{ getForReviewCount() }})">
                  <!-- REVIEW ACTIONS LEGEND -->
                  <div *ngIf="projectOwner && getForReviewIndexes().length > 0" class="actions-legend">
                    <span class="legend-label">Review Actions:</span>
                    <div class="legend-item">
                      <div class="action-chip approve-chip legend-chip"><mat-icon>check</mat-icon></div>
                      <span class="legend-text">Approve</span>
                    </div>
                    <div class="legend-item">
                      <div class="action-chip reject-chip legend-chip"><mat-icon>close</mat-icon></div>
                      <span class="legend-text">Reject</span>
                    </div>
                    <div class="legend-item">
                      <div class="action-chip add-master-chip legend-chip"><mat-icon>add</mat-icon></div>
                      <span class="legend-text">Add to Master Mitigations</span>
                    </div>
                  </div>

                  <mat-accordion class="mt-2 d-block" *ngIf="getForReviewIndexes().length > 0">
                    <ng-container *ngFor="let idx of getForReviewIndexes(); let j = index">
                      <ng-container
                        *ngTemplateOutlet="mitigationPanelTemplate; context: { index: idx, m: riskMetricCreateForm.controls[idx], displayIndex: j }"></ng-container>
                    </ng-container>
                  </mat-accordion>
                  <div *ngIf="getForReviewIndexes().length === 0" class="empty-tab-state">
                    <mat-icon>task_alt</mat-icon>
                    <span>No tasks pending review</span>
                  </div>
                </mat-tab>

                <mat-tab label="Work in Progress ({{ getWipIndexes().length }})">
                  <mat-accordion class="mt-3 d-block" *ngIf="getWipIndexes().length > 0">
                    <ng-container *ngFor="let idx of getWipIndexes(); let j = index">
                      <ng-container
                        *ngTemplateOutlet="mitigationPanelTemplate; context: { index: idx, m: riskMetricCreateForm.controls[idx], displayIndex: j }"></ng-container>
                    </ng-container>
                  </mat-accordion>
                  <div *ngIf="getWipIndexes().length === 0" class="empty-tab-state">
                    <mat-icon>hourglass_empty</mat-icon>
                    <span>No tasks in progress</span>
                  </div>
                </mat-tab>

                <mat-tab label="Completed Tasks ({{ getCompletedIndexes().length }})">
                  <mat-accordion class="mt-3 d-block" *ngIf="getCompletedIndexes().length > 0">
                    <ng-container *ngFor="let idx of getCompletedIndexes(); let j = index">
                      <ng-container
                        *ngTemplateOutlet="mitigationPanelTemplate; context: { index: idx, m: riskMetricCreateForm.controls[idx], displayIndex: j }"></ng-container>
                    </ng-container>
                  </mat-accordion>
                  <div *ngIf="getCompletedIndexes().length === 0" class="empty-tab-state">
                    <mat-icon>check_circle_outline</mat-icon>
                    <span>No completed tasks yet</span>
                  </div>
                </mat-tab>
              </mat-tab-group>

              <!-- Approval Comments and Action Buttons -->
              <div class="form-row" style="margin-top: 12px; display: flex; align-items: center; gap: 10px;">
                <div class="form-label" style="width: auto; margin:0px;"> Risk Leader Comments<span
                    style="color: red; margin-left: 2px;">*</span></div>
                <mat-form-field class="w-50" appearance="outline" style="margin-bottom: -1.25em;">
                  <textarea matInput [(ngModel)]="approvalComments" [ngModelOptions]="{ standalone: true }"
                    placeholder="Enter comments..." [disabled]="!showApprovalControls()" cdkTextareaAutosize
                    cdkAutosizeMinRows="1" cdkAutosizeMaxRows="6"></textarea>
                </mat-form-field>
                <button type="button" mat-button mat-stroked-button (click)="openHistory()" style="height: 36px;">
                  <mat-icon>history</mat-icon>
                  History
                </button>
              </div>



              <div class="checkbox-row" style="margin-top: 12px;"
                *ngIf="projectOwner && (isMitigateCheckboxEnabled() || isClosedByCro())">
                <mat-checkbox class="risk-warning-checkbox" [(ngModel)]="mitigateCheckboxChecked"
                  [ngModelOptions]="{ standalone: true }" [disabled]="!isMitigateCheckboxEnabled()"
                  (change)="showMitigateCheckboxError = false">
                  <span class="checkbox-text" [ngClass]="{ 'checkbox-error': showMitigateCheckboxError }">
                    This risk is backed by adequate preventive, detective & mitigation
                    controls - accepting it does not pose material exposure to
                    the business.
                  </span>
                </mat-checkbox>
              </div>
            </form>


          </mat-tab>
          <!-- <mat-tab label="Scoring Matrix">
            <div class="p-4 scoring-matrix">
              <div class="table-responsive overflow-auto pe-2">
                <table class="table table-bordered text-center">
                  <thead>
                    <tr>
                      <th class="diagonal">
                        <span>Likelihood</span>
                        <span>Impact</span>
                      </th>
                      <th *ngFor="let impact of riskImpactList" style="background-color: #b0b0ae; color: #111">
                        {{ impact.display_name }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let likelihood of riskLikelihoodList; let i = index">
                      <td class="fw-bold">
                        {{ likelihood.display_name }}
                      </td>
                      <td *ngFor="let impact of riskImpactList" [ngStyle]="{
                            'background-color': getScoreColor(getRiskScore(impact.name, likelihood.name)),
                            'color': 'white',
                            'position': 'relative'
                          }" [ngClass]="{
                            'selected-cell': isSelectedCell(impact.id, likelihood.id),
                            'residual-selected-cell': isResidualSelectedCell(impact.id, likelihood.id)
                          }">
                        {{ getRiskScore(impact.name, likelihood.name) }}
                        <div class="badge-container">
                          <span *ngIf="isSelectedCell(impact.id, likelihood.id)" title="Inherent Risk"
                            class="inherent-badge">Inherent</span>
                          <span *ngIf="isResidualSelectedCell(impact.id, likelihood.id)" title="Residual Risk"
                            class="residual-badge">Residual</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="risk-legend mt-3">
                <div class="legend-title">
                  Likelihood × Impact = Risk Score
                </div>
                <div class="legend-row">
                  <div class="legend-range">{{ getRiskRanges().low }}</div>
                  <div class="legend-box low">Low</div>
                </div>
                <div class="legend-row middle">
                  <div class="legend-range">{{ getRiskRanges().medium }}</div>
                  <div class="legend-box medium">Medium</div>
                </div>
                <div class="legend-row">
                  <div class="legend-range">{{ getRiskRanges().high }}</div>
                  <div class="legend-box high">High</div>
                </div>
              </div>

              <div class="mt-3">
                <b>Note:</b>
                <div>
                  <b>Inherent risk</b> refers to the level of risk that exists in the absence of any controls or
                  mitigations.
                </div>
                <div>
                  <b>Residual risk</b> is the level of risk that remains after controls, measures, or mitigations have
                  been applied.
                </div>
              </div>
            </div>


          </mat-tab> -->
          <mat-tab label="Airo Cue">
            <div class="p-3" style="min-height: 250px;">
              <app-llm-inference inferenceType="risk" [outputRef]="{ project_risk_id: res?.id }"
                viewMode="full"></app-llm-inference>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
    <div class="dialog-footer">
      <button mat-button color="secondary" (click)="closeDialog()">
        Close
      </button>

      <div *appHasAccess="{ roles: ['!vendor'] }" style="display: flex; gap: 8px;">
        <button mat-button mat-stroked-button color="primary" (click)="saveMetric(false)"
          *ngIf="selectedMainTabIndex === 0 && riskMetric.risk_response === 'Mitigate' && isMitigateCheckboxEnabled()"
          [disabled]="isReadOnlyStatus() || isClosedByCro()">
          Save
        </button>
        <button mat-raised-button color="primary" (click)="saveMetric(isMitigateCheckboxEnabled())"
          *ngIf="selectedMainTabIndex === 0 && riskMetric.risk_response && (!isMitigateCheckboxEnabled() || projectOwner)"
          [disabled]="isReadOnlyStatus() || isClosedByCro() || (riskMetric.risk_response === 'Accept' && !projectOwner)">
          {{ isMitigateCheckboxEnabled() ? 'Approve Risk' : 'Save' }}
        </button>
      </div>
    </div>
  </div>
</div>


<ng-template #historyDialogTemplate>
  <div class="modal-dialog m-0" style="max-width: 100%">
    <div class="modal-content" style="border: none">
      <app-modal-header-common [title]="'Risk Comment History'" [dialogRef]="historyDialogRef">
      </app-modal-header-common>
      <div class="form-scrollable-area" style="min-height: 400px; padding: 16px;">
        <app-action-history [actionId]="res?.id" historyType="risk"></app-action-history>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #actionHistoryDialogTemplate let-actionId>
  <div class="modal-dialog m-0" style="max-width: 100%">
    <div class="modal-content" style="border: none">
      <app-modal-header-common [title]="'Action Comment History'" [dialogRef]="actionHistoryDialogRef">
      </app-modal-header-common>
      <div class="form-scrollable-area" style="min-height: 400px; padding: 16px;">
        <app-action-history [actionId]="actionId"></app-action-history>
      </div>
    </div>
  </div>
</ng-template>